import { React, useState, useEffect } from "react";
import { Button, Form, Input } from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../../Assets/Icons/alertGreen.svg";
import { DisabledStyles } from "../../../pageStyled";
import { approveRejectJobCard } from "../../../../Services/deckleMatchServices";

const { TextArea } = Input;

const JobCardRejectDrawer = ({
  visible,
  onClose,
  onCloseGrade,
  jobId,
  setReFetch,
  setActionResponse,
  showToaster,
  jobcardCode
}) => {
  // const [actionResponse, setActionResponse] = useState({});
  const [isRejectLoading, setIsRejectLoading] = useState(false);
  const [form] = Form.useForm();

  const rejectJobCard = async (jobId, reason) => {
    setIsRejectLoading(true)
    await approveRejectJobCard({ id: jobId, state: "rejected", comment: reason })
      .then((response) =>
        setActionResponse({ error: response.error, msg: response.msg })
      )
      .catch((error) => {
        console.log(error.response.data);
        setActionResponse({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
      }).finally(() => {
        setIsRejectLoading(false)
      });
  };

  const onFinish = async (e) => {
    await rejectJobCard(jobId, e.reason);
    onCloseGrade();
    setReFetch(true);
    showToaster();
  };

  useEffect(() => {
    form.resetFields();
  }, [jobId]);

  return (
    <RightDrawerSidebar
      title="Reject Job Card"
      subtitle=""
      visible={visible}
      onClose={onCloseGrade}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <HaberForm>
            <Form
              name="basic"
              form={form}
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              onFinish={onFinish}
            >
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Job Card Number</h5>
                  <p>An auto-generated code to identify job card</p>
                </div>

                <DisabledStyles>
                  <Form.Item
                    name="jobId"
                    rules={[{ required: true }]}
                    initialValue={jobcardCode}
                  >
                    <Input disabled className="requestChangeValue" />
                  </Form.Item>
                </DisabledStyles>
              </div>

              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Reason</h5>
                  <p>Please specify a reason for rejecting this job card</p>
                </div>
                <Form.Item
                  name="reason"
                  rules={[{ required: true }]}
                  className=""
                >
                  <TextArea
                    maxLength={100}
                    style={{ height: 90 }}
                    placeholder={"Text"}
                  />
                </Form.Item>
              </div>
              <div className="buttonFlex fixedBtm">
                <Form.Item>
                  <Button htmlType="submit" className="themeBtn" loading={isRejectLoading}>
                  {!isRejectLoading &&  <Iconmoon icon="wrong-file" size={16} color="#ffffff" />}
                    Reject Job Card
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
        </div>

        <AlertContainer
          color="yellow btmFix"
          icon={alertBlue}
          msg="Once a Job Card is rejected, it cannot be appreoved or recovered later."
        />
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default JobCardRejectDrawer;
